import React from 'react';
import CrudPage from '../../components/CrudPage';
import { questionApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'id' },
  { header: 'Question', field: 'statement' },
  { header: 'Answers', field: 'answers', render: (v) => v ? `${v.length} answers` : '0 answers' },
];

const formFields = [
  { name: 'statement', label: 'Question Statement', type: 'textarea', required: true },
];

const QuestionPage = () => (
  <CrudPage
    title="Questions"
    subtitle="Manage onboarding questions"
    api={questionApi}
    columns={columns}
    formFields={formFields}
    idField="id"
    searchField="statement"
    addUrl="/admin/question/new"
    editUrl="/admin/question/:id/edit"
  />
);

export default QuestionPage;
